import { RoutesList } from "src/containers/routes";

export namespace RouteService {
    export const getCurrentRoute = () => {

        const split = window.location.pathname.toLowerCase().split("/");
        let currentRoute = RoutesList.find((x) => {

            let result: typeof x | undefined = undefined;

            x.path.forEach((y) => {

                const s = (y.toLowerCase()).split("/");

                if (s.filter((x) => !x.endsWith("?")).length !== split.length) return undefined;

                if (s.every((y, index) => y.startsWith(":") || split[index] === y))
                    result = x;

            });

            return result;
        });


        return currentRoute;

    };
}